module.exports = __webpack_public_path__ + "static/media/hall-P10.53401091.svg";